<template>
  <div class="block">
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle' && showingMap"
      :key="puzzleNumber"
      :number="Math.round(puzzleNumber / 2)"
      :name="`https://brownben.github.io/images/memory/${puzzleNumber}.jpg`"
      :options="options"
      :keyboard="false"
      :countdown="false"
      :hideSkip="showingMap"
      @complete="puzzleComplete"
    />
    <puzzle-tall
      v-if="currentStage === 'puzzle' && !showingMap"
      :key="puzzleNumber"
      :number="Math.round(puzzleNumber / 2)"
      :name="`https://brownben.github.io/images/memory/${puzzleNumber}.jpg`"
      :options="options"
      :keyboard="false"
      :countdown="false"
      :hideSkip="showingMap"
      @complete="puzzleComplete"
    />
    <pause
      v-if="currentStage === 'pause'"
      :solution="solution[Math.round(puzzleNumber / 2) - 1]"
      :legCorrect="lastLegCorrect"
      @nextPuzzle="nextPuzzle"
    />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="''"
      :time="userTime"
      :score="userScore"
    />
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/PuzzleSmall'
import PuzzleTall from '@/components/PuzzleTall'
import Pause from '@/components/Pause'
import GameOver from '@/components/GameOver'

export default {
  components: {
    Countdown,
    Puzzle,
    PuzzleTall,
    Pause,
    GameOver,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'countdown',
      choices: [],
      times: [],
      userScore: '',
      userScoreNumber: 0,
      userTime: 0,
      solution: ['A', 'D', 'A', 'B', 'B'],
    }
  },

  computed: {
    lastLegCorrect: function() {
      return (
        this.solution[Math.round(this.puzzleNumber / 2) - 1] ===
        this.choices[Math.round(this.puzzleNumber / 2) - 1]
      )
    },

    options: function() {
      if (this.puzzleNumber % 2 === 0) return ['A', 'B', 'C', 'D']
      else return ['Go']
    },

    showingMap: function() {
      return this.puzzleNumber % 2 === 1
    },
  },

  methods: {
    startGame: function() {
      this.currentStage = 'puzzle'

      if (this.puzzleNumber >= this.solution.length * 2) {
        this.currentStage = 'gameover'

        this.userScore = this.scoreUser()
        this.userTime = this.times.reduce((a, b) => a + b, 0)
      }
    },

    puzzleComplete: function(result) {
      if (this.puzzleNumber % 2 === 0) {
        this.choices.push(result.choice)
        this.times.push(result.time)

        this.currentStage = 'pause'
      } else {
        this.times.push(result.time)
        this.puzzleNumber += 1
      }
    },

    nextPuzzle: function() {
      if (this.puzzleNumber >= this.solution.length * 2) {
        this.currentStage = 'gameover'

        this.userScore = this.scoreUser()
        this.userTime = this.times.reduce((a, b) => a + b, 0)
      } else {
        this.puzzleNumber += 1
        this.currentStage = 'puzzle'
      }
    },

    scoreUser: function() {
      let correct = 0
      let i = 0

      while (i < this.choices.length) {
        if (this.solution[i] === this.choices[i]) correct += 1
        i += 1
      }

      this.userScoreNumber = correct
      return `${correct}`
    },
  },
}
</script>
